




















import { Vue, Component, Model, Emit, Prop } from "vue-property-decorator";

@Component
export default class SearchTextField extends Vue {
  @Model("input", { type: String, default: "" })
  value!: string;

  @Emit("input")
  emitInput(value: string) {
    return value;
  }

  @Prop({ type: String, default: "Gõ để tìm" })
  placeholder!: string;

  clearText() {
    this.emitInput("");
  }

  get inputListeners() {
    const inputEvent = (event: Event) => {
      this.emitInput((event.target as HTMLInputElement).value);
    };

    return {
      ...this.$listeners,
      input: inputEvent
    };
  }
}
